import { render, staticRenderFns } from "./newVendor.vue?vue&type=template&id=63b3a92a&"
import script from "./newVendor.vue?vue&type=script&lang=js&"
export * from "./newVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports